import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { resetPassword, pushErrors, clearMessages } from '../actions'
import { initErrors } from '../reducers'

import Spinner from 'react-tiny-spin'
import { spinnerConfig } from '../../../common/globals'

import {
  SuccessMessage,
  ErrorMessage,
  InputMessage,
  StatusMessage
} from './Messages'

const mapStateToProps = state => {
  return {
    loading: state.loading,
    errors: state.errors,
    showSuccess: state.showSuccess,
    showError: state.showError,
  }
}

const mapDispatchToProps = {
  resetPassword,
  pushErrors,
  clearMessages,
}

class Main extends Component {

  handleSubmit = (e) => {
    e.preventDefault()
    this.props.clearMessages()

    let customerId = ReactDOM.findDOMNode(this._customerId).value
    let userId = ReactDOM.findDOMNode(this._userId).value

    let errors = this.validate(customerId, userId)

    if (Object.keys(errors).some(error => errors[error])) {
      this.props.pushErrors(errors)
      return
    }

    this.props.resetPassword(customerId, userId)
  }

  validate(customerId, userId) {
    let errors = initErrors

    if (customerId.length === 0)
      errors = { ...errors, customerId: true }
    if (userId.length === 0)
      errors = { ...errors, userId: true }

    return errors
  }


  render() {
    const { loading, errors } = this.props
    let customerError = errors.customerId
    let userError = errors.userId

    if (selfService !== 'active') {
      return (
        <div className='cb-container-fluid'>
          <div className="cb-notification cb-notification-notify">
            <i className="cb-icon icon-warning"></i>
            <span className="cb-notification-text">
              We're sorry, this feature is unavailable at this time.
            </span>
          </div>
        </div>
      )
    }

    return (
      <div className='cb-container-fluid'>
        <div id='resetForm'>
          <div className="cb-card">

            <div className="cb-card-block">
              <h4 className='cb-card-title'>Password Reset</h4>

              <div style={{ display: (this.props.showSuccess) ? 'none' : ''}}>
                { (userStatus !== '') ? <StatusMessage status={userStatus}/> : null }

                <p>To reset your password, please complete the information below.</p>

                {loading ? <Spinner config={spinnerConfig} /> : null}

                <form>
                  <div className={`cb-form-group ${customerError ? 'cb-has-error' : ''}`}>
                    <label className="cb-form-control-label" htmlFor="customerId">Customer ID</label>
                    <input
                      id="customerId"
                      ref={customerId => this._customerId = customerId}
                      className={`cb-form-control ${userError ? 'cb-form-control-error' : ''}`}
                      type="text"
                      disabled={loading}
                      autoComplete="false"
                    />
                    { customerError ? <InputMessage type={'Customer'} /> : null }
                  </div>

                  <div className={`cb-form-group ${userError ? 'cb-has-error' : ''}`}>
                    <label className="cb-form-control-label" htmlFor="userId">User ID</label>
                    <input
                      id="userId"
                      ref={userId => this._userId = userId}
                      className={`cb-form-control ${userError ? 'cb-form-control-error' : ''}`}
                      type="text"
                      disabled={loading}
                      autoComplete="false"
                    />
                    { userError ? <InputMessage type={'User'} /> : null }
                  </div>

                  { this.props.showError ? <ErrorMessage /> : null }

                  <button className="cb-btn cb-btn-primary cb-btn-block"
                          disabled={loading}
                          onClick={this.handleSubmit}>Submit</button>
                </form>
              </div>

              { this.props.showSuccess ? <SuccessMessage /> : null }

              <div className="cb-text-sm-center" style={{ marginTop: '.5rem' }}>
                <a className="cb-link" href={HOME_PAGE}>Go Back</a>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)